import React from 'react';

import { cx } from 'helpers/StylingHelpers';

import Badge from '../Badge/Badge';

import type { TYPES } from '../Badge/Badge';
import type { ValueOf } from 'types';

import styles from './BadgeLabel.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string,
  badge?: React.ReactNode,
  type: ValueOf<typeof TYPES>,
  children?: React.ReactNode
}

const BadgeLabel = (props: Props) => {

  const {
    className,
    badge,
    type,
    children,
    ...rest
  } = props;

  // Render

  return (
    <div
      className={cx(
        styles.root,
        { [styles[type]]: type },
        className,
      )}
      {...rest}
    >
      <Badge type={type}>{badge}</Badge>
      {
        children && (
          <div className={styles.label}>
            {children}
          </div>
        )
      }
    </div>
  );
};

export default BadgeLabel;
